module.exports = __webpack_public_path__ + "img/PencilSimpleLine-blue.0ef14989.svg";